import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { reviewerReducer } from "./reviewerReducer";
import { reviewerInitialState } from "./reviewerInitialState";
import ReviewerContext from "./ReviewerContext";


export const useReviewerContext = () => useContext(ReviewerContext)


export function ReviewerProvider() {
    const [reviewerState, reviewerDispatch] = useReducer(
        reviewerReducer,
        reviewerInitialState
    )

    return (
        <ReviewerContext.Provider value={{ reviewerState, reviewerDispatch }}>
            <Outlet />
        </ReviewerContext.Provider>
    )
}
